/* tslint:disable */
import { NewsletterResource } from "./NewsletterResource"

export class NewsletterListResource {
		errorCode: number;
		errorMessage: string;
		numberOfPages: number;
		newsletterList: NewsletterResource[];

}
